<template>
  <v-container fluid grid-list-xl>
    <app-card :fullBlock="true">
      <v-toolbar flat="flat">
        <v-toolbar-title class="title">Noticias</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Buscar"
          append-icon="search"
          single-line="single-line"
          hide-details="hide-details"
        ></v-text-field>
      </v-toolbar>
      <v-btn
        class="mx-4"
        to="news/new"
        color="green"
        small="small"
        outlined="outlined"
      >
        <v-icon left="left">add</v-icon>Agregar
      </v-btn>
      <v-data-table
        :headers="table.headers"
        :items="news"
        :search="search"
        :loading="table.loading"
        items-per-page-text="Paginas por filas"
        no-data-text="Sin elementos"
        no-results-text="Sin resultados"
      >
        <template v-slot:item.created="{ item }">
          <span>{{ item.created | date }}</span>
        </template>
        <template v-slot:item.id="{ item }">
          <v-icon @click="editNews(item)" small="small">edit</v-icon>
          <v-icon
            class="ml-4"
            @click="openDialog(item)"
            color="red"
            small="small"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </app-card>
    <v-dialog v-model="dialog" persistent max-width="306">
      <v-card>
        <v-card-title class="headline">Eliminar</v-card-title>

        <v-card-text class="subtitle-1 font-weight-medium"
          >Deseas eliminar la noticia?</v-card-text
        >

        <v-card-actions>
          <v-progress-circular
            v-show="loading"
            indeterminate
            size="30"
            color="primary"
          ></v-progress-circular>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closedDialog()">No</v-btn>

          <v-btn color="green darken-1" text @click="removeItem()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { formatDateNew } from "../../filters";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "News",
  filters: {
    date(value) {
      return formatDateNew(value);
    },
  },
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    table: {
      loading: false,
      headers: [
        {
          text: "Título",
          value: "title",
        },
        {
          text: "Estatus",
          value: "active",
        },
        {
          text: "Fecha de creación",
          value: "created",
        },
        {
          text: "Acciones",
          value: "id",
          align: "center",
          sortable: false,
        },
      ],
      item: null,
    },
  }),
  created() {
    this.table.loading = true;
    this.loadNews().finally(() => (this.table.loading = false));
  },
  computed: {
    ...mapGetters(["news"]),
  },
  methods: {
    editNews(news) {
      this.$router.push("news/" + news.id);
    },
    async removeItem() {
      this.loading = true;
      let response = await this.removeNew(this.item);
      if (response) {
        this.loadNews().finally(() => (this.table.loading = false));
        this.$emit("show-snackbar", "Se ha eliminado la noticia");
        this.loading = false;
        this.dialog = false;
        return;
      }
      this.$emit("show-snackbar", "Ha ocurrido un error");
      this.loading = false;
      this.dialog = false;
    },
    openDialog(item) {
      this.dialog = true;
      this.item = item;
    },
    closeDialog() {
      dialog = false;
      this.item = null;
    },
    ...mapActions({
      loadNews: "loadNews",
      removeNew: "RemoveNew",
    }),
  },
};
</script>
